/*
* options:
message
type
title
time
icon
forceIcon (icon is auto-set if the type changes, to override, set this to true)
data

These options available in new toast(); and toastobj.set();
* */
var toast = function(options) {

  if (!(this instanceof toast)) {
    return new toast(options);
  }

  this.$container = $("#toaster-notifications-container");

  var that = this;
  if (!this.$container.length) {
    this.$container = $("<div/>", {
      id: "toaster-notifications-container"
    });
    $("body").append(this.$container);
  }
  // options is required...
  if (typeof options === 'undefined') {
    return false;
  }

  if (typeof options !== "object") {
    options = {message: options};
  }

  // message is required on creation of toast. (but NOT on changing of toast)
  if (typeof options.message === 'undefined') {
    return false;
  }

  this.iconDefault = {info: "info-circle", danger: "times", warning: "exclamation-triangle", success: "check"};

  this.removeToastInnerMethod = function($shell) {
    $shell.removeClass("toast-active");
    var moveDownBy = $shell.height();
    $shell.css("opacity", 0);
    $shell.nextAll(".toaster-notification-shell").each(function() {

      var oldTop = parseInt($(this).prop("style").top);
      $(this).css("top", oldTop + moveDownBy + 25);

    });
    setTimeout(function() {
      $shell.remove();
    }, 10000);
  };

  this.calculateFromTop = function($except) {
    var fromTop                 = 0;
    var $mostRecentNotification = $(".toast-active").not($except).not("[data-moving='yes']").last();
    if ($mostRecentNotification.length) {
      if ($mostRecentNotification.attr("data-moving") === "yes") {
        fromTop =
          parseInt($mostRecentNotification.prop('style').top) +
          500 +
          (($mostRecentNotification.height() * -1) - 25);
      }
      else {
        fromTop = parseInt($mostRecentNotification.prop('style').top);
      }

    }
    return fromTop;
  };


  this.set = function(options) {

    this.setOptions(options);
    if (this.message !== null && typeof this.message === "string" && this.message.substring(0, 5) === "<html") {
      this.type = "danger";
    }

    if (this.pastType !== this.type && this.pastIcon === this.icon && !this.forceIcon) {
      this.icon = this.iconDefault[this.type];
    }

    var timeoutToClear = this.timeout;
    var $title         = "";

    var append = true;
    var $shell;

    if (this.shell !== null) {
      $shell = this.shell;
      append = false;
    }
    else {
      $shell = $("<div/>", {
        class: 'toaster-notification-shell toast-active'
      });
    }

    var $notification = $("<div/>", {
      class: 'toaster-notification card-body card card-body bg-' + this.type + '-with-text'
    });
    if (this.title !== "") {
      $title = $("<span/>", {
        html: "<strong>" + this.title + "</strong><br><br>"
      });
    }

    if (this.icon === "loader") {
      this.icon = "circle-o-notch fa-spin fa-fw";
    }
    var $icon;
    if (this.icon !== "none") {
      $icon = "<i class='notificationTypeIcon fa fa-" + this.icon + "'></i> ";
    }
    else {
      $icon = "";
    }

    var $message    = $("<span></span>").addClass('message').html(this.message);
    var $close_icon = $("<div>×</div>").addClass('close-toaster-notification').addClass('cursor-pointer');

    $notification.on("click", ".close-toaster-notification", function() {
      that.close();
    });

    var $content = $("<span/>");


    $content.append([$title, $message]);

    $shell.html("");
    $shell.append($notification.append([$icon, $content, $close_icon]));

    if (append) {


      $shell.css({top: -500 + this.calculateFromTop(), opacity: "0", position: "absolute", "transition-duration": "1s"})
            .attr("data-moving", "yes");

      this.$container.append($shell);
      setTimeout(function() {
        $shell.css({top: (($shell.height() * -1) - 25) + that.calculateFromTop($shell), opacity: 1}).attr("data-moving", "no");
      });


    }
    clearTimeout(timeoutToClear);
    if (this.time > -1) {
      this.timeout = setTimeout(function() {


        that.removeToastInnerMethod($shell);


      }, this.time);
    }
    this.shell    = $shell;
    this.pastIcon = this.icon;
    this.pastType = this.type;


  };


  this.close = function() {
    if (this.shell !== null) {
      clearTimeout(this.timeout);
      that.removeToastInnerMethod(this.shell);
    }
  };

  this.remove = function() {
    this.close();
  };

  this.setOptions = function(options) {
    // options is required...
    if (typeof options === 'undefined') {
      return false;
    }

    if (typeof options !== "object" || $.isArray(options)) {
      options = {message: options};
    }

    if ($.isArray(options.message)) {
      var temp        = options.message;
      options.message = temp[0];
      options.type    = temp[1];

    }


    options.message = typeof options.message !== 'undefined' ? options.message : this.message || "";
    options.type    = options.type || this.type || 'info';
    options.title   = typeof options.title !== 'undefined' ? options.title : this.title || "";
    options.time    = typeof options.time !== 'undefined' ? options.time : this.time || 3500;
    options.icon    = typeof options.icon !== 'undefined' ? options.icon : this.icon || this.iconDefault[options.type];
    options.data    = typeof options.data !== 'undefined' ? options.data : this.data || false;


    if (options.icon === "default") {
      options.icon = this.iconDefault[options.type];
    }

    if (options.icon === "") {
      options.icon = "none";
    }

    for (var property in options) {
      if (options.hasOwnProperty(property)) {
        this[property] = options[property];
      }
    }

  };

  this.pastType = null;
  this.pastIcon = null;
  this.timeout  = null;
  this.shell    = null;
  this.set(options);

};

